import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { environment } from '../../environments/environment';

@Component({
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
  imports: [MatButtonModule, MatDialogModule]
})
export class AboutDialogComponent {
  protected readonly environment = environment;

  constructor(private dialog: MatDialogRef<AboutDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  public ok() {
    this.dialog.close();
  }
}
